import axios from "axios";

// Same-origin by default (dev server proxies /api; production serves both behind one host).
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
});

// PREVIEW MODE (build-time flag only): route every request to the in-browser sample store.
// Production builds never set REACT_APP_PREVIEW, so the mock module is not compiled in.
export const IS_PREVIEW = process.env.REACT_APP_PREVIEW === "1";
if (IS_PREVIEW) {
  api.defaults.adapter = require("@/preview/mock").previewAdapter;
}

// Broadcast auth failures so the AuthContext can drop the session.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !String(err.config?.url || "").includes("/auth/")) {
      window.dispatchEvent(new CustomEvent("wappy:unauthorized"));
    }
    return Promise.reject(err);
  },
);

export default api;
